export default {
	general: {
		save: 'Tallenna',
		cancel: 'Peruuta',
		yes: 'Kyllä',
		no: 'Ei',
		goBack: 'Palaa takaisin',
		changeCookieSettings: 'Muuta evästeasetuksiasi',
	},
	routes: {
		error404: {
			title: 'Sivua ei löytynyt',
		},
		membershipCard: {
			title: 'Kortti',
		},
		myAccount: {
			title: 'Omat tiedot',
			headline: 'Omat tiedot',
		},
		volunteer: {
			title: 'Osallistu',
			headline: 'Vapaaehtoistoiminta',
		},
		materials: {
			title: 'Materiaalit',
			headline: 'Ladattavat tiedostot',
		},
		benefits: {
			title: 'Edut',
			headline: 'Jäsenedut',
		},
		pages: {
			title: 'Sivut',
			headline: 'Sivut',
		},
		page: {
			title: 'Sivu',
			headline: 'Sivu',
		},
		memberships: {
			title: 'Jäsenyys',
			headline: 'Tietoa jäsenyydestä',
		},
		membership: {
			title: 'Jäsenyys',
			headline: 'Jäsenyys',
		},
		assignments: {
			title: 'Tehtävät',
			headline: 'Tehtävät',
		},
		assignment: {
			title: 'Tehtävä',
			headline: 'Tehtävä',
		},
		invoices: {
			title: 'Laskut',
			headline: 'Laskuarkisto',
		},
		invoice: {
			title: 'Lasku',
			headline: 'Lasku',
		},
		compensations: {
			title: 'Hae korvausta',
			headline: 'Hae korvausta',
		},
		settings: {
			title: 'Asetukset',
			headline: 'Asetukset',
		},
	},
	cookieTypes: {
		necessary: 'Välttämättömät',
		statistics: 'Tilastointi',
		marketing: 'Markkinointi',
	},
	validationErrors: {
		required: 'Tämä kenttä on pakollinen.',
		email: 'Tarkista sähköpostiosoitteen muotoilu.',
	},
}
